/**
 * railAppIcons — the single source of truth for the Hugeicons app-rail glyphs.
 *
 * The navigation config (navigationConfig.ts) stores lucide icons. The app rail
 * (ErpSidebarAppRail) renders Hugeicons instead, keyed by each app's stable
 * `href`. This map is shared so other surfaces (e.g. the "แอปของคุณ" grid in
 * QuickActions) render the SAME glyph as the rail instead of the lucide default.
 *
 * Any app whose href isn't mapped here falls back to its lucide `app.icon`.
 */
import { type IconSvgElement } from "@hugeicons/react";
import {
  Home01Icon,
  UserAdd01Icon,
  ContactIcon,
  InboxIcon,
  BubbleChatIcon,
  ChartLineData01Icon,
  WebDesign01Icon,
  Mail01Icon,
  Note01Icon,
  News01Icon,
  GridTableIcon,
  ComputerIcon,
  PackageDeliveredIcon,
  DashboardSquare01Icon,
} from "@hugeicons/core-free-icons";
import type { NavigationItem } from "@/lib/config/navigationConfig";

export const RAIL_ICONS: Record<string, IconSvgElement> = {
  "/business": Home01Icon,
  "/crm": UserAdd01Icon,
  "/twenty-crm": ContactIcon,
  "/inbox": InboxIcon,
  "/raven": BubbleChatIcon,
  "/insights": ChartLineData01Icon,
  "/storefront/collections": WebDesign01Icon,
  "/mail": Mail01Icon,
  "/affine": Note01Icon,
  "/blog": News01Icon,
  "/sheets": GridTableIcon,
  "/pos": ComputerIcon,
  "/fulfillment": PackageDeliveredIcon,
  "/apps": DashboardSquare01Icon,
};

/** The Hugeicons rail icon for an app, or undefined if it isn't mapped yet. */
export function railHugeIcon(app: NavigationItem): IconSvgElement | undefined {
  return app.href ? RAIL_ICONS[app.href] : undefined;
}
